import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import { Card } from '@mui/material';
import { dshCardHeight, dshCardScrollHeight } from 'config';
import DshBoxTitle from '../Box/DshBoxTitle';
import DashboardVoteListTable from '../Table/DashboardVoteListTable';


function VoteStatusCard({ votesOfTheMeeting, setVoteInputStatus, scroll = true }) {

    return (
        <Card

            sx={{
                m: 0,
                p: '10px',
                marginBottom: 0,
                minHeight: `${dshCardHeight}`,
                // height: `${dshPreviousCardHeight}`,

            }}
        >


            <DshBoxTitle color="primary" title={`Oylama Durumu`} />



            {scroll ? (
                <JumboScrollbar
                    autoHeight
                    autoHeightMax={`${dshCardScrollHeight}`}
                    autoHide
                    autoHideDuration={200}
                    autoHideTimeout={500}
                >
                    <DashboardVoteListTable agendaVotes={votesOfTheMeeting} setVoteInputStatus={setVoteInputStatus} otherScroll={true} />
                </JumboScrollbar>
            ) : (
                <DashboardVoteListTable agendaVotes={votesOfTheMeeting} setVoteInputStatus={setVoteInputStatus} otherScroll={'none'} />
            )}

        </Card >
    );
};

VoteStatusCard.defaultProps = {
    setVoteInputStatus: undefined,
};
export default VoteStatusCard